import { z } from "zod";

export const schema = z.object({
	id_empresa: z.number().int("Selecione a empresa antes de continuar"),
	id_cidade: z.coerce
		.number({ invalid_type_error: "Selecione uma cidade" }) // Converte o valor para número
		.int("O campo id_cidade deve ser um número inteiro.") // Valida que é inteiro
		.refine((val) => val > 0, {
			// Garante que seja maior que 0
			message: "Selecione uma cidade válida",
		}),
	contato: z.string().min(1, "Campo nome do contato é obrigatório"),
	nome: z.string().min(1, "Campo empresa é obrigatório"),
	rua: z.string().min(1, "Campo endereço é obrigatório"),
	numero: z
		.union([z.string(), z.null()]) // Permite string ou null
		.refine((value) => value !== null && value.trim().length > 0, {
			message: "Campo número é obrigatório, se não houver número, digite s/n",
		}),
	complemento: z.string().nullable(),
	bairro: z
		.string({
			required_error: "Campo bairro é obrigatório",
			invalid_type_error: "Campo bairro é obrigatório",
		})
		.min(1, "Campo bairro é obrigatório")
		.refine((val) => val.trim().length > 0, {
			message: "Campo bairro é obrigatório",
		}),
	telefone_1: z.string().min(1, "Campo telefone é obrigatório"),
	cpf: z
		.string({
			required_error: "Campo cpf/cnpj é obrigatório",
			invalid_type_error: "Campo cpf/cnpj é obrigatório",
		})
		.min(1, "Campo cpf/cnpj é obrigatório")
		.refine((val) => val.trim().length > 0, {
			message: "Campo cpf/cnpj é obrigatório",
		}),
	email: z.string().nullable(),
	cep: z.union([z.string(), z.null()]).refine(
		(cep) => {
			if (!cep) return false; // Trata null e string vazia como inválidos
			const trimmedCep = cep.trim();
			return /^\d{5}-\d{3}$/.test(trimmedCep);
		},
		{
			message: "CEP inválido.",
		}
	),

	cidade: z.string().nullable(),
});

export const defaultValuesSchema = {
	id_empresa: 0,
	id_cidade: 0,
	contato: "",
	nome: "",
	rua: "",
	numero: "",
	complemento: "",
	bairro: "",
	telefone_1: "",
	cpf: "",
	email: "",
	cep: "",
	cidade: "",
};
